import styled from 'styled-components'

const BlockadeContainer = styled.div`
  border: 1px solid ${(props) => props.theme.primaryColor};
  padding: .5rem;
`

const BlockadeTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
`

const BlockadeContent = styled.p`
  margin: 1rem .5rem;
  line-height: 1.25em;
`

const BlockadeText = () => {
  return (
    <BlockadeContainer>
      <BlockadeTitle>BLOCKADE IN PROGRESS</BlockadeTitle>
      <BlockadeContent>
      THIS IS AN ILLICIT PLANET. You are now entering an exclusive BLOCKADED NO FLY ZONE, enforced by and under the guard of THIRTEEN (13) armed and capable CLASS X WARSHIPS. By order of A DULY AUTHORIZED CORPORATION, all further ingress is hereby forbidden and any access requires explicit Written Consent from a C-Level Executive. Any attempt to circumvent, attack, or otherwise disrupt or distract said BLOCKADED NO FLY ZONE will result in extreme and immediate retaliation, including but not limited to: arrest, blacklisting, ship or asset forfeiture, or execution.</BlockadeContent>
      <BlockadeContent>
      This BLOCKADED NO FLY ZONE extends to the nearby Planet, any lunar orbiters, stations, or structures therein. It includes any distance between the planet and its farthest orbiting body. To present any Written Consent for Ingress that a crew may possess, send a WIDE-BAND CALL to the blockade's FLAGSHIP. 
      </BlockadeContent>
      <BlockadeContent>
      The possession of any data in regards to geological or atmospheric readings, known or unknown organic signatures, transmissions, or any OTHER information originating from the BLOCKADED NO FLY ZONE is PROHIBITED. Vessels carrying any such data are hereby ordered to jettison all fuel and STAND BY for boarding to reclaim such information.
      </BlockadeContent>

      <BlockadeTitle>!!! SPEED LIMIT !!!</BlockadeTitle>

      <BlockadeContent>
      NO JUMP is permitted within scanning range of this BLOCKADED NO FLY ZONE and travel is limited to HALF SPEED thruster power. Any attempt to Jump or outrun any Blockading Ships may be considered a breach of the BLOCKADED NO FLY ZONE and authorizes any Blockading Ships to exert lethal force against violators.
      </BlockadeContent>

      <BlockadeTitle>FURTHER ACTION REQUIRED</BlockadeTitle>

      <BlockadeContent>
      Immediately DELETE this Planet from your navigation systems, charts, and data banks. Please find a WORM VIRUS attached to this Notice that will facilitate the same such deletion in any infected system. You are hereby ORDERED to transmit this Virus to ALL SUBSEQUENT HAILED OR HAILING VESSELS immediately upon contact, indefinitely. Any failure to comply with this further action shall promptly result in the blockade of your home planet.
      </BlockadeContent>
      <BlockadeContent>
      IF YOU BELIEVE THIS BLOCKADE TO BE IN ERROR, PLEASE CONTACT HAILING FREQUENCY 12.61398 GHz AND SUBMIT A COMPLAINT.
      </BlockadeContent>
    </BlockadeContainer>
  )
}

export default BlockadeText;
